import {
    apiRequest,
    penilaianDashboard
} from "../../../../services/adapters/kepegawaian/penilaian360Service"

class Penilaian360Repository 
{
    fetchDashboard = async (query) => {
        return await apiRequest("get", penilaianDashboard, {
            params: query
        }, true)
    }

}

export default Penilaian360Repository